/* @indexer:no-export */
import * as React from 'react';
import { getAdditionalProps } from '../utils';
export var getTbodyProps = getAdditionalProps('dm-table__body');
export function TableGroup(_ref, ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    role: "rowgroup",
    className: className
  }, children);
}
export default React.forwardRef(TableGroup);